import { FC, useState, useEffect } from 'react';
import { Form, FormProps } from '../../../../lib/components';

export type CompanyFormProps = FormProps & { onStateChanged?: (state: boolean) => void };

export const CompanyForm: FC<CompanyFormProps> = (props) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const handleDirtyChanged = (dirty: boolean) => {
    setIsDirty(dirty);
    setCanSubmit(dirty && isValid);
    props.onDirtyChanged?.(dirty);
  };

  const handleValidityChanged = (valid: boolean) => {
    setIsValid(valid);
    setCanSubmit(isDirty && valid);
    props.onValidityChanged?.(valid);
  };

  useEffect(() => {
    props.onStateChanged?.(canSubmit);
  }, [canSubmit]);

  return (
    <Form {...props} onDirtyChanged={handleDirtyChanged} onValidityChanged={handleValidityChanged}>
      {props.children}
    </Form>
  );
};
